var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Game: "+_vm._s(this.game.displayName)+"\n  "),_c('button',{on:{"click":function($event){return _vm.downloadCSV()}}},[_vm._v("Download CSV")]),(_vm.csv)?_c('pre',[_vm._v(_vm._s(this.csv))]):_vm._e(),_c('a',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"linker"})])
}
var staticRenderFns = []

export { render, staticRenderFns }